import { InjectionToken } from '@angular/core';

/**
 * Environment Configuration Interface
 */
export interface EnvironmentConfig {
  production: boolean;
  demo: boolean;
  name: string;
  apiUrl: string;
  apiBaseUrl: string;
  features: {
    enableAnalytics: boolean;
    enableErrorReporting: boolean;
    enableDebugMode: boolean;
    enableMockData: boolean;
  };
  logging: {
    level: string;
    enableConsoleLogging: boolean;
    enableRemoteLogging: boolean;
  };
  app: {
    version: string;
    defaultLanguage: string;
    supportedLanguages: string[];
    sessionTimeout: number;
  };
  storage: {
    prefix: string;
    authTokenKey: string;
    userKey: string;
    settingsKey: string;
  };
  demoConfig?: {
    autoLogin?: boolean;
    login?: {
      email?: string;
      password?: string;
      rememberMe?: boolean;
      autoSubmit?: boolean;
      seedUserOnLogin?: boolean;
      allowAnyCredentials?: boolean;
    };
    demoUser?: {
      id?: string | number;
      name?: string;
      email?: string;
      user_id?: string;
    };
    apiDelay?: number;
    errorRate?: number;
    errorStatusCodes?: number[];
  };
}

/**
 * Injection token for environment configuration
 */
export const ENVIRONMENT_CONFIG = new InjectionToken<EnvironmentConfig>(
  'ENVIRONMENT_CONFIG'
);

/**
 * Runtime environment detection
 */
export const IS_DEMO_MODE = window.location.host.includes('demo');
export const IS_DEV_ENV = /dev|localhost/.test(window.location.host);
export const IS_TEST_ENV =
  Object.prototype.hasOwnProperty.call(globalThis, 'jasmine') ||
  Object.prototype.hasOwnProperty.call(globalThis, 'jest');
